
<!--业主大会统一社会信用代码证书 -->
<template>
  <div class="OwnerCertificate">
    <!-- <div class="title col-33 tx-c">业主大会统一社会信用代码证书</div> -->
    <div class="basInfo-table">
      <div class="row">
        <div class="title">业主大会统一社会信用代码证书</div>
      </div>
      <div class="row">
        <div class="col">统一社会信用代码：</div>
         <div class="col">{{detailObj.UnifiedSocialCreditCode}}</div>
      </div>
      <div class="row">
        <div class="col">业主大会名称：</div>
         <div class="col">{{detailObj.OrgName}}</div>
      </div>
      <div class="row">
        <div class="col">地址：</div>
         <div class="col">{{detailObj.Address}}</div>
      </div>
      <div class="row">
        <div class="col">负责人：</div>
         <div class="col">{{detailObj.MasterName}}</div>
      </div>
      <div class="row">
        <div class="col">发证日期：</div>
         <div class="col">{{detailObj.SendDate|subDate()}}</div>
      </div>
      <div class="row">
        <div class="col">有效期：</div>
         <div class="col">{{times|formatDate('yyyy-MM-dd') }} 至 {{ detailObj.BusinessLicenseValidTime|subDate()}}</div>
      </div>
      <div class="row">
        <div class="col">发证机关：</div>
         <div class="col">{{detailObj.IcenseIssueOrg}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { OpenControllerSvr } from '@/service/OpenControllerSvr/OpenControllerSvr';
export default {
  components: {},
  props: {},
  data() {
    return {
      detailObj: {},
      times: null,
    };
  },
  filters: {
    subDate(val) {
      return val ? val.substr(0, 10) : '-';
    },
  },
  created() {},
  mounted() {
    new OpenControllerSvr()
      .newGetOwnerTeam(this.$route.query.crCode)
      .then((res) => {
        if (res != null) {
          this.detailObj = res;
          this.times = new Date(res.BusinessLicenseValidStartTime).getTime();
        } else {
          this.$message({
            type: 'error',
            message: '无效统一社会信用代码',
          });
        }
      })
      .catch((err) => {
        this.$message({
          type: 'error',
          message: err.Msg,
        });
      });
  },
};
</script>
<style lang="scss" scoped>
.OwnerCertificate {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  padding: 0 5px;
  .title {
    font-size: 20px;
    font-weight: 600;
    padding: 20px;
  }
  .basInfo-table {
    max-width: 800px;
    margin: 15px auto;
    .col {
      &:first-child {
        width: 140px;
      }
    }
  }
}
</style>
